module.exports = __webpack_public_path__ + "static/media/pos_product_management.814e2aee.jpg";